import { createSlice } from '@reduxjs/toolkit';

import initialState, * as handlers from './handlers';

const interviewFinalQuestions = createSlice({
  name: 'interviewSession',
  initialState,
  reducers: {
    setInterviewFinalQuestions: handlers.setInterviewFinalQuestions,
    setInterviewFinalQuestionAnswer: handlers.setInterviewFinalQuestionAnswer,
    clearInterviewFinalQuestionAnswer:
      handlers.clearInterviewFinalQuestionAnswer,
  },
});

export const { actions, reducer } = interviewFinalQuestions;

export const {
  setInterviewFinalQuestions,
  setInterviewFinalQuestionAnswer,
  clearInterviewFinalQuestionAnswer,
} = actions;

export default reducer;
